import { http } from "./http";
import {
  AdminResetPasswordRequest,
  AdminUpdateUserRequest,
  CreateAdminUserRequest,
  FindAllUsersRequest,
  FindAllUsersResponse,
  FindMeResponse,
  FindUserInfoResponse,
  UpdateUserInfoRequest,
} from "@/types/api/user";

export async function findMe(): Promise<FindMeResponse> {
  return http.get<FindMeResponse>("/api/user/me");
}

export async function findMeSilent(): Promise<FindMeResponse> {
  return http.getSilentAuth<FindMeResponse>("/api/user/me");
}

export async function findUserInfo(): Promise<FindUserInfoResponse> {
  return http.get<FindUserInfoResponse>("/api/user/info");
}

export async function updateUserInfo(req: UpdateUserInfoRequest): Promise<void> {
  return http.patch<void>("/api/user/update", req);
}

export async function findAllUsers(req: FindAllUsersRequest): Promise<FindAllUsersResponse> {
  const params = new URLSearchParams({
    page: String(req.page),
    limit: String(req.limit),
    ...(req.search ? { search: req.search } : {}),
  });
  return http.get<FindAllUsersResponse>(`/api/user/list?${params}`);
}

export async function createAdminUser(req: CreateAdminUserRequest): Promise<void> {
  return http.post<void>("/api/user/admin", req);
}

export async function adminUpdateUser(id: number, req: AdminUpdateUserRequest): Promise<void> {
  return http.patch<void>(`/api/user/admin/${id}`, req);
}

export async function enableUser(id: number): Promise<void> {
  return http.patch<void>(`/api/user/enable/${id}`, {});
}

export async function disableUser(id: number): Promise<void> {
  return http.delete<void>(`/api/user/${id}`);
}

export async function adminResetPassword(id: number, req: AdminResetPasswordRequest): Promise<void> {
  return http.patch<void>(`/api/user/reset-password/${id}`, req);
}
